import {createSelector} from 'reselect';

const getVehicleslist = state => state.vehiclesList;

export const selectvehicleslisttype = createSelector(
  [getVehicleslist],
  vehiclesList => vehiclesList,
);
